<template>
  <div>
    <ClientBookings v-if="isClient"/>
  </div>
</template> 

<script>

import ClientBookings from "@/components/bookings/client/ClientBookings";

export default {
  name: 'Bookings',
  components: { ClientBookings },
  data() {
    return {}
  },
  computed: {
    isClient() {
      return this.$store.getters['auth/isClient'];
    },
    user() {
      return this.$store.getters['auth/getUser'];
    }
  },
  async mounted(){
    //fetch client bookings from here
    if(this.$store.state.booking.bookings.length === 0){
      await this.$store.dispatch('fetchClientBookings', this.user.id);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>